import { IUserAuthenticationState } from ".";
import { AUTHENTICATION_SUCCESS, AUTHENTICATION_FAIL, LOGIN_START, LOGOUT, SIGN_UP_START, SIGN_UP_SUCCESS, EMAIL_CONFIRMED } from "./actions";
import { IAuthResult } from "api/Auth0";

/* login actions  */
export const loginStart = () => ({ type: LOGIN_START })
export const authenticationSuccess = (authentication: IUserAuthenticationState) => ({
    type: AUTHENTICATION_SUCCESS,
    payload: authentication
})
export const authenticationFail = (reason: string) => ({ type: AUTHENTICATION_FAIL })

export const signUpStart = () => ({ type: SIGN_UP_START })

// User Signed Up Into system (the first time)
export const signUpSuccess = (authentication: IAuthResult) => ({ type: SIGN_UP_SUCCESS, payload: authentication })

export const emailConfirmedSuccess = (email: string) => ({ type: EMAIL_CONFIRMED, payload: { email } })
export const logout = () => ({ type: LOGOUT })



// WEBPACK FOOTER //
// ./src/store/modules/authentication/actionCreators.ts